module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAMCAYAAABr5z2BAAAAAXNSR0IArs4c6QAAALxJREFUKBVjbJo09wjDfwZrBjIAIwPDMRaQ5uL0ODK0MzD0zlxkxUSWTiRNWA34/+snw6uKIoY7ihJgDGKDxLABrAa87Wpj+LhwHsP/Hz/AGMQGiWEDWA34tGo5htpPq5ZhiIEEsBrAyIQpzMiIKYbTAP7YRAzb+OOSMMRAAizYRAXzixn+/fjO8BnqFd6wSAaQGDaA1QBGFhYGkeoGMMamCVkMu8eQVRBgM85csv7/y7fvCCjDLi0mLMQAAAZzOQNO1pYEAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flag-japanese.png
// module id = wpyx
// module chunks = 29